import React, { Component } from 'react';
import { News } from '../News.interface';
import { environments } from 'environments/environments';
import SingleNewsPreview from '../SingleNewsPreview/SingleNewsPreview';
import { Link } from 'react-router-dom';
import DTHead from 'assets/img/DT_head.png';
import './SingleNewsFull.css';

export default class SingleNewsFull extends Component {
  state = {
    news: {
      id: 0,
      addTime: 0,
      time: 0,
      shortText: '',
      fullText: ''
    } as News,
    loading: true,
    displayLoading: false,
    error: false
  }

  mounted = false;
  controller = new AbortController();

  componentDidMount() {
    this.mounted = true;
    this.getCurrentNews();
    this.showLoadingMessage();
  }

  componentWillUnmount() {
    this.mounted = false;
    this.controller.abort();
  }

  /** Displays loading message if news aren't loaded in short time */
  showLoadingMessage() {
    setTimeout(() => {
      if (this.state.loading && this.mounted) {
        this.setState({ displayLoading: true });
      }
    }, 400);
  }

  /** Load selected news */
  getCurrentNews() {
    this.setState({ loading: true });
    const newsId = +(this.props as any).match.params.id || 0;
    const params = `c=id=${newsId}`;
    fetch(`${environments.server}${environments.backend}?${params}`, { signal: this.controller.signal })
      .then(async res => {
        const news: News[] = await res.json();
        // console.log(news);
        setTimeout(() => {
          if (news[0] && news[0].shortText) {
            this.setState({ news: news[0], loading: false, error: false });
          } else {
            this.setState({ error: true, loading: false })
          }
        }, this.state.displayLoading ? 500 : 0);
      }).catch(e => {
        if (this.mounted) {
          this.setState({ error: true, loading: false });
        }
      });
  }

  render() {
    const renderLoadingHead = this.state.loading
      ? <span className="loading loading-spinner"></span>
      : <img className="small-loading-head" src={DTHead} alt="+" />;
    const renderLoading = <div className="news-body not-done section">
      <p>{renderLoadingHead} Novinka se načítá, vyčkejte prosím... {renderLoadingHead}</p><br />
      <p>...nebo ji zkuste načíst <span onClick={() => this.getCurrentNews()}>ZNOVU</span>, jestli to trvá moc dlouho.</p>
    </div>;
    const renderError = <div className="news-body not-done section">
      <p>Novinku se nepovedlo načíst.</p>
      <p>
        Zkuste to <span onClick={() => this.getCurrentNews()}>ZNOVU </span>
        nebo se podívejte na ostatní <b><Link to="/novinky">NOVINKY</Link></b>.
      </p>
    </div>;

    return (
      <div className="single-news-full section">
        <Link to="/novinky" className="event-link-back">&larr; Zpět na novinky</Link>
        <p></p>
        {this.state.loading
          ? this.state.displayLoading
            ? renderLoading
            : null
          : this.state.error
            ? renderError
            : <SingleNewsPreview news={this.state.news} full={true} />
        }
      </div>
    );
  }
}
